<div id="homePage">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="container-fluid h-100">
            <div class="row w-100 h-100">
                <div class="col-5">
                    <div class="btn-group menu h-100" role="group">

                        <button type="button" class="menuItem" [ngClass]="isActive(1)" (click)="setActiveTab(1)"
                            routerLink="/home/shipment">{{ 'home.shipmentMenu' | translate }}</button>
                        <button type="button" class="menuItem" [ngClass]="isActive(2)" (click)="setActiveTab(2)"
                            routerLink="/home/guarantee">{{ 'home.guaranteeMenu' | translate }}</button>

                    </div>
                </div>

                <div class="col-2 logoContent">
                    <img src="assets/images/cacesa.svg" alt="logo" class="logoImg">
                </div>

                <div class="col-5 userDropdown">
                    <div class="h-100 float-end d-flex">
                        <i class="icon-user userIcon"></i>
                        <div class="userInfo">
                            <span class="userTitle">{{user.name}}</span> <br>
                            <span class="userSubtitle">{{ 'home.session' | translate }} {{user.lastSession}}</span>
                        </div>
                        <div class="dropdown">
                            <button class="btn btn-secondary dropdown-toggle h-100" type="button" id="dropdownMenu"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="icon-caret-down"></i>
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdownMenu">
                                <li><button class="dropdown-item" type="button" (click)="openChangePassword()"> <i
                                            class="icon-lock align-middle" aria-hidden="true"></i> <span
                                            class="align-middle">{{ 'home.changePassword' | translate }}</span></button></li>
                                <li><button class="dropdown-item" type="button" (click)="logout()"> <i
                                            class="icon-logout align-middle" aria-hidden="true"></i><span
                                            class="align-middle">{{ 'home.logout' | translate }}</span></button>
                                </li>
                            </ul>
                        </div>
                        <div class="divider"></div>

                        <div class="dropdownLanguage">
                            <button class="btn btn-secondary dropdown-toggle h-100" type="button" id="dropdownMenu2"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <span class="align-middle"> {{language}}</span> <i class="icon-caret-down align-middle"></i>
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                <li><button class="dropdown-item" type="button" (click)="useLanguage('en')"> <span
                                            class="align-middle">{{ 'home.english' | translate }}</span></button></li>
                                <li><button class="dropdown-item" type="button" (click)="useLanguage('pol')"> <span
                                            class="align-middle">{{ 'home.polish' | translate }}</span></button>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </nav>
    <router-outlet></router-outlet>
    <app-modal #modal [modalConfig]="modalConfig">

        <form [formGroup]="formEditPassword" novalidate>
            <div class="row">
                <div class="col-12">
                    <div class="formField input-group passwordInput mb-3">
                        <input type="text" class="form-control passwordFile"
                            [type]="fieldTextType ? 'text' : 'password'" aria-label="Current Password"
                            formControlName="current_pass"><button class="btn btn-eye" type="button"
                            (click)="toggleFieldTextType()"> <i
                                [ngClass]="{'icon-eye-close': !fieldTextType,  'icon-eye': fieldTextType }"></i></button>
                        <label alt="current_pass" for="current_pass" class="labelForm">{{ 'home.currentPass' | translate }}</label>
                    </div>

                </div>
                <div class="col-12 mb-3">
                    <div class="formField input-group ">
                        <input type="text" class="form-control passwordFile" minlength="6" maxlength="16"
                            [type]="fieldTextType ? 'text' : 'password'" aria-label="New Password" id="newPassword"
                            formControlName="new_pass"><button class="btn btn-eye" type="button"
                            (click)="toggleFieldTextType()"> <i
                                [ngClass]="{'icon-eye-close': !fieldTextType,  'icon-eye': fieldTextType }"></i></button>
                        <label alt="new_pass" for="new_pass" class="labelForm">{{ 'home.newPass' | translate }}</label>

                    </div>

                    <div>
                        <small class="text-muted textCounter">{{newPass.value?.length || 0}}/16</small>
                    </div>


                </div>
                <div class="col-12 pb-4">
                    <div class="formField input-group ">
                        <input type="text" class="form-control passwordFile" minlength="6" maxlength="16"
                            [type]="fieldTextType ? 'text' : 'password'" aria-label="Confirm Password"
                            formControlName="confirm_pass"><button class="btn btn-eye" type="button"
                            (click)="toggleFieldTextType()"> <i
                                [ngClass]="{'icon-eye-close': !fieldTextType,  'icon-eye': fieldTextType }"></i></button>
                        <label alt="confirm_pass" for="confirm_pass" class="labelForm">{{ 'home.confirmPass' | translate }}</label>
                    </div>
                    <div>
                        <small class="text-muted textCounter">{{confirmPass.value?.length || 0}}/16</small>
                    </div>

                </div>

                <div class="col-12 pt-4 pb-2 colButtonForm">
                    <button type="submit" class="btn btnModalConfirm btn-primary float-end"
                        [disabled]="!formEditPassword.valid" (click)="changePassword()">{{ 'home.save' | translate }}</button>
                </div> 
            </div>
        </form>
    </app-modal>
    <footer class="footer">
        <p class="text-center">
            {{ 'home.footer' | translate }}
        </p>
    </footer>
</div>